import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SellCustomerGroupFormComponent } from "../sell-customer-group-form/sell-customer-group-form.component";

@Component({
  selector: "ngx-sell-customer-group-list",
  templateUrl: "./sell-customer-group-list.component.html",
  styleUrls: ["./sell-customer-group-list.component.scss"],
})
export class SellCustomerGroupListComponent extends BaseListComponent {
  constructor() {
    super();
    this.inputEditorform = SellCustomerGroupFormComponent;
  }
  ngOnInit() {
    this.apiName = "SellCustomerGroup";
    this.areaName = "SellCustomer";
    this.label = "گروهبندی مشتری";
  }
}
